/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch } from 'react-router-dom';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { EarthquakeSearchPage } from './search/EarthquakeSearchPage';
import { EarthquakeContainer } from './data/EarthquakeContainer';
import { EarthquakeEditPage } from './edit/EarthquakeEditPage';
import { EarthquakeInfoPage } from './info/EarthquakeInfoPage';
import { withUser } from '../../../auth/withUser';
import { isDataManager } from '../../../../role/roleUtils';

const EarthquakeUnwrapped = ({ basePath, authorities }) => {
  const dataManager = isDataManager(authorities);

  return (
    <Switch>
      <Route exact path={`${basePath}/search`} component={EarthquakeSearchPage} />
      <Route exact path={`${basePath}/event-data`} component={withUser(EarthquakeContainer)} />
      { dataManager && <Route exact path={`${basePath}/update/:id`} render={props => (<EarthquakeEditPage key={props.match.params.id} {...props} />)} />}
      { dataManager && <Route exact path={`${basePath}/update`} render={props => (<EarthquakeEditPage {...props} />)} />}
      <Route exact path={`${basePath}/event-more-info/:eqId`} component={withUser(EarthquakeInfoPage)} />
      <Redirect to={`${basePath}/search`} />
    </Switch>
  );
};

EarthquakeUnwrapped.propTypes = {
  basePath: PropTypes.string.isRequired,
  authorities: ImmutablePropTypes.list.isRequired,
};

export const Earthquake = withUser(EarthquakeUnwrapped);
